"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tableResizeHandleClassNames: function() {
        return tableResizeHandleClassNames;
    },
    useTableResizeHandleStyles_unstable: function() {
        return useTableResizeHandleStyles_unstable;
    }
});
const _react = require("@griffel/react");
const tableResizeHandleClassNames = {
    root: 'fui-TableResizeHandle'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        qhf8xq: "f1euv43f",
        j35jbq: [
            "f1e31b4d",
            "f1vgc2s3"
        ],
        Bhzewxz: "f15twtuk",
        B5kzvoi: "f1yab3r1",
        a9b677: "fjw5fx7",
        jrapky: 0,
        Frg6f3: 0,
        t21cq0: 0,
        B6of3ja: 0,
        B74szlk: "fg06o1j",
        Bceei9c: "fc3en1c",
        abs64n: "fk73vx1",
        Bmy1vo4: "f13u1uyl",
        B3o57yi: "fezquic",
        Bj3rh1h: "f19g0ac",
        B3cna0y: "f1tkae59",
        Brovlpu: "ftqa4ok",
        B7zu5sd: "f15pjodv",
        Bs6t6z0: "ftgrb5f",
        Fdvyjd: "f2df6js",
        Biobvvw: "fshsryb",
        Hdbjpj: "f11ef69",
        jc51t6: [
            "f12lb1dx",
            "f13tbxeo"
        ],
        u6d25: "fu4ulse",
        Bj55yzk: "fw2wsqs",
        Bkbwdz4: "f1swzn7y"
    }
}, {
    d: [
        ".f1euv43f{position:absolute;}",
        ".f1e31b4d{right:0;}",
        ".f1vgc2s3{left:0;}",
        ".f15twtuk{top:0;}",
        ".f1yab3r1{bottom:0;}",
        ".fjw5fx7{width:16px;}",
        [
            ".fg06o1j{margin:0 -8px;}",
            {
                p: -1
            }
        ],
        ".fc3en1c{cursor:col-resize;}",
        ".fk73vx1{opacity:0;}",
        ".f13u1uyl{transition-property:opacity;}",
        ".fezquic{transition-duration:.2s;}",
        ".f19g0ac{z-index:1;}",
        ".ftgrb5f:after{content:\" \";}",
        ".f2df6js:after{display:block;}",
        ".fshsryb:after{width:1px;}",
        ".f11ef69:after{position:absolute;}",
        ".f12lb1dx:after{left:50%;}",
        ".f13tbxeo:after{right:50%;}",
        ".fu4ulse:after{top:0;}",
        ".fw2wsqs:after{bottom:0;}",
        ".f1swzn7y:after{background-color:var(--colorNeutralStroke1);}"
    ],
    f: [
        ".f1tkae59:focus{opacity:1;}",
        ".ftqa4ok:focus{outline-style:none;}"
    ],
    h: [
        ".f15pjodv:hover{opacity:1;}"
    ]
});
const useTableResizeHandleStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(tableResizeHandleClassNames.root, styles.root, state.root.className);
    return state;
}; //# sourceMappingURL=useTableResizeHandleStyles.styles.js.map
